<template>
  <div class="main-form" v-if="value">
    <div class="main-form__content">
      <div class="main-form__close" @click="$emit('input', false)">
        <div></div>
      </div>
      <form action="" @submit.prevent="onFormSubmit">
        <main-input
          class="my-3 w-100"
          placeholder="Номер телефона*"
          v-model="phone"
          type="tel"
          v-mask="'+38(0##)-###-##-##'"
          :rules="rules.isPhone"
          required
        />
        <main-input
          class="my-3 w-100"
          placeholder="ФИО*"
          v-model="fullName"
          type="text"
          :rules="rules.required"
          required
        />
        <autocomplete
          class="v-input w-100 mb-3"
          :search="fetchCities"
          placeholder="Введите Ваш город*"
          autoSelect
          :get-result-value="getCityValue"
          :debounce-time="500"
          @submit="onCitySelected"
        ></autocomplete>
        <autocomplete
          class="v-input w-100 mb-3"
          :disabled="!warehouses.length"
          :search="filterWarehouses"
          placeholder="Выберите отделение*"
          autoSelect
          :get-result-value="getWarehouseValue"
          :debounce-time="500"
          @submit="onWarehouseSelected"
        ></autocomplete>
        <h6 class="mb-3" v-if="deiveryCost">
          Стоимость доставки: {{ deiveryCost }} грн.
        </h6>
        <button-simple type="submit" primary :disabled="!isFormValid"
          >Оплатить</button-simple
        >
      </form>
    </div>
  </div>
</template>

<script>
const savvaApiUrl = "https://savva-libkin.com/api/v2/order-book";
const apiUrl = "https://api.novaposhta.ua/v2.0/json/";
const apiKey = "d09e5c6db42e2e7b3c7f32c61fa09340";

const isPhone = (value) =>
  /((\+38)?\(?\d{3}\)?[\s\.-]?(\d{7}|\d{3}[\s\.-]\d{2}[\s\.-]\d{2}|\d{3}-\d{4}))/.test(
    value
  ) || "Некорректный номер телефона";

const required = (value) => value.length > 3 || "Мин. 3 символа";

import mainInput from "@/components/mainInput.vue";
import buttonSimple from "@/components/buttonSimple.vue";
import Autocomplete from "@trevoreyre/autocomplete-vue";

export default {
  name: "mainForm",
  components: {
    mainInput,
    Autocomplete,
    buttonSimple,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sign: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      phone: "+38",
      fullName: "",
      city: "",
      cityRef: null,
      warehouse: "",
      warehouses: [],
      deiveryCost: null,
      rules: {
        isPhone,
        required,
      },
    };
  },
  computed: {
    isFormValid() {
      return (
        this.rules.isPhone(this.phone) === true &&
        this.warehouse &&
        this.city &&
        this.deiveryCost &&
        this.rules.required(this.fullName) === true
      );
    },
  },
  methods: {
    async fetchCities(search = "") {
      if (search.length < 3) return [];
      const res = await fetch(`${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          apiKey,
          methodProperties: null,
          modelName: "Address",
          calledMethod: "searchSettlements",
          language: "ru",
          methodProperties: {
            CityName: search,
            Limit: 5,
          },
        }),
      });
      const { data } = await res.json();
      return data[0].Addresses;
    },
    async fetchWarehouses(cityRef) {
      if (!cityRef) return [];
      const res = await fetch(`${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          apiKey,
          methodProperties: null,
          modelName: "AddressGeneral",
          calledMethod: "getWarehouses",
          language: "ru",
          methodProperties: {
            CityRef: cityRef,
          },
        }),
      });
      const { data } = await res.json();
      this.warehouses = data;
      //   console.log(data);
      //   return data;
    },
    filterWarehouses(search = "") {
      return this.warehouses.filter((warehouse) =>
        warehouse.DescriptionRu.includes(search)
      );
    },
    getCityValue(result) {
      return result.MainDescription;
    },
    getWarehouseValue(result) {
      return result.DescriptionRu;
    },
    onCitySelected(value) {
      console.log(value);
      this.city = value.MainDescription;
      this.cityRef = value.Ref;
      const { DeliveryCity } = value;
      this.fetchWarehouses(DeliveryCity);
    },
    onWarehouseSelected(value) {
      this.warehouse = value.DescriptionRu;
      this.calculateDeliveryCost();
    },
    async calculateDeliveryCost() {
      const formData = {
        modelName: "InternetDocument",
        calledMethod: "getDocumentPrice",
        methodProperties: {
          CitySender: "db5c88d0-391c-11dd-90d9-001a92567626",
          CityRecipient: this.cityRef,
          ServiceType: "WarehouseWarehouse",
          Cost: 270,
          CargoType: "Parcel",
          SeatsAmount: "1",
          Weight: 1,
          volumetricWidth: 23,
          volumetricLength: 27,
          volumetricHeight: 10,
          // OptionsSeat: [{
          //   weight: "1",
          //   volumetricWidth: 23,
          //   volumetricLength: 27,
          //   volumetricHeight: 10,
          //   packRef: "dc389dfe-3106-11e5-add9-005056887b8d",
          // }],
          PackCalculate: {
            PackCount: "1",
            PackRef: "dc389dfe-3106-11e5-add9-005056887b8d",
          },
        },
        // apiKey: "[ВАШ КЛЮЧ]",
      };
      const res = await fetch(`${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          apiKey,
          ...formData,
        }),
      });
      const { data } = await res.json();
      // this.deiveryCost = data[0].Cost  + data[0].CostPack;
      this.deiveryCost = data[0].Cost + 20;
    },
    async onFormSubmit() {
      const formData = {
        time_delivery: null,
        call_me_back: true,
        restaurant_id: 33,
        payment: "cart",
        address: `Город: ${this.city} Отделение: ${this.warehouse}`,
        comment: `Подпись на книге: ${this.escapeHtml(
          this.sign
        )}. Стоимость доставки: ${this.deiveryCost}`,
        shipping: "from_restaurant",
        last_name: "-",
        first_name: this.escapeHtml(this.fullName),
        telephone: this.phone,
        products: [{ product_id: "623", qty: "1" }],
        deivery_cost: this.deiveryCost,
      };
      const res = await fetch(`${savvaApiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      console.log(data);
      if (data.link_for_pay) window.location.href = data.link_for_pay;
      //   console.log(data);
      //   console.log(this.phone, this.city, this.warehouse, this.sign);
    },
    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../stylesheets/main";
.main-form {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1200;
  &__content {
    background: $light;
    padding: 20px 30px;
    position: relative;
    max-width: 350px;
    width: 100%;
  }
  &__close {
    position: absolute;
    top: 5px;
    right: 5px;
    > div {
      position: relative;
      width: 30px;
      height: 30px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &::before,
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        background: $dark;
        position: absolute;
        transform: rotate(-45deg);
      }
      &::before {
        transform: rotate(45deg);
      }
    }
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>